module.exports = __webpack_public_path__ + "img/empty.5288d6e3.png";